import { i18n } from ".";
import { getNestedKeyValue, type NestedKey } from "../nestedKey";

export type NumberFormat = {
    currency: string | Intl.NumberFormatOptions;
    decimal: string | Intl.NumberFormatOptions;
    percent: string | Intl.NumberFormatOptions;
};

export const n = (value: number, key: NestedKey<NumberFormat>, options?: Intl.NumberFormatOptions, locale?: string) => {
    const languageCode = locale ?? `${i18n.value.locale}-${i18n.value.country}`;

    const localeToCurrency: Record<string, string> = {
        "da-DK": "DKK",
        "sv-SE": "SEK",
        "en-US": "USD",
    };

    const format: NumberFormat = {
        currency: {
            style: "currency",
            currencyDisplay: "symbol",
            currency: localeToCurrency[languageCode],
            minimumFractionDigits: 0,
        },
        decimal: {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
        percent: {
            style: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        },
    };

    const formatOptions = getNestedKeyValue<NumberFormat, NestedKey<NumberFormat>, Intl.NumberFormatOptions>(format, key);
    return new Intl.NumberFormat(languageCode, { ...formatOptions, ...options }).format(value);
};
